import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import router from './router';
import store from './store';
import ApiService from './api';
import CaptchaService from './services/captcha';
import App from './App.vue';
import UIComponents from '@/components/UI';
import KC, {install} from '@/keycloak';
import {vMaska} from "maska"
import Notifications from 'vue-notification';
import reactive from '@/directives/reactive';
import vClickOutside from 'v-click-outside'
import vBlur from 'v-blur';
import VueMeta from 'vue-meta'
import CipherLink from '@/components/CipherLink';
import VuePortal from '@linusborg/vue-simple-portal'
import {fetchEnv} from "@services/env";

require('./assets/scss/main.scss');

Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false;
Vue.use(ApiService);
Vue.use(CaptchaService);
Vue.use(VueCompositionAPI);
Vue.directive("maska", vMaska)
Vue.use(Notifications);
Vue.use(Vue.directive('reactive', reactive));
// Директива чтобы слушать нажатия вне компонента
Vue.use(Vue.directive('click-outside', vClickOutside.directive));
Vue.use(vBlur);
Vue.use(VueMeta);
Vue.use(VuePortal, {selector: '#portal', name: 'Portal'});
Vue.component('CipherLink', CipherLink);

// глобальная регистрация UI-компонентов
UIComponents.forEach((component) => {
	Vue.component(component.name, component);
});

try {
	fetchEnv().then(() => {
		Vue.use(install);
		KC.instance()
			.setCallbacks({
				onAuthSuccess: App.methods.onAuthSuccess,
				onAuthRefreshSuccess: App.methods.onTokenChange,
				onAuthError: App.methods.onTokenChange,
				onAuthRefreshError: App.methods.onTokenChange,
				onAuthLogout: App.methods.onAuthLogout,
				//onTokenExpired: App.methods.tokenChangeHandler,
			})
			.init()
			.then(async () => {

				const tokenValidityMilliseconds = KC._TOKEN_MIN_VALIDITY_SECONDS * 1000 - 10 * 1000;

				setInterval(() => {
					KC.instance()
						.updateToken(KC._TOKEN_MIN_VALIDITY_SECONDS)
						.catch(e => console.error(e))
				}, tokenValidityMilliseconds);

				new Vue({
					router,
					store,
					render: (h) => h(App),
				}).$mount('#app');
			}).catch(e => console.error(e));

		// Убиваем регистрацию сервис воркера
		(() => {
			if ('serviceWorker' in navigator) {
				navigator.serviceWorker.getRegistrations().then(function (registrations) {
					for (let registration of registrations) {
						registration.unregister();
					}
				});
			}
		})();
	});
} catch (e) {
	console.error(e)
}